var __jsx = React.createElement;
import React from 'react';
import { Col, Row, Container, Button } from 'react-bootstrap';

var BCTerms = function BCTerms(props) {
  var close = props.close;
  return __jsx(Container, null, __jsx(Row, null, __jsx(Col, {
    xs: 12,
    lg: 8,
    className: "p-3 bg-white my-5"
  }, __jsx("p", {
    className: ""
  }, "Situa\u021Bia \xEEnscrierii la Biroul de Credit poate fi obtinu\u021B\u0103 prin Conso dac\u0103 urmatoarele condi\u021Bii sunt \xEEndeplinite simultan:"), __jsx("ul", {
    className: ""
  }, __jsx("li", null, "deschizi gratuit un cont Conso"), __jsx("li", null, "\xEEnregistrezi o solicitare de credit valid\u0103 \xEEn contul Conso \xEEn ultimele 7 zile"), __jsx("li", null, "procedura de autentificare la Biroul de Credit este finalizat\u0103 cu succes"), __jsx("li", null, "nu ai solicitat un alt raport de credit prin Conso \xEEn ultimele 3 luni")), __jsx("p", {
    className: "font-weight-bold"
  }, "Primul pas const\u0103 \xEEn solicitarea unei oferte de credit prin Conso, ap\u0103s\xE2nd butonul Solicit\u0103 Ofert\u0103."), __jsx("p", null, "Din motive de securitate, accesul la acest serviciu poate fi restric\u021Bionat de catre Conso \xEEn cazul unor tentative nereu\u0219ite de autentificare la Biroul de Credit pentru a proteja datele personale ale utilizatorilor."), __jsx(Button, {
    onClick: close
  }, "\xCEnchide"))));
};

export default BCTerms;